import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideCallout,
  GuidePillar,
  GuidePillarGrid,
} from "../GuideBlocks.js";

const AhavibesPerspectiveSection = ({ heading, accentIndex = 2 }) => (
  <GuidePanel sectionId="ahavibes-perspective" heading={heading} accentIndex={accentIndex}>
    <GuideCallout variant="amber">
      At Ahavibes, mental clarity is not a feel-good concept. It is a leadership capability.
    </GuideCallout>
    <GuidePillarGrid columns={3}>
      <GuidePillar title="Think with structure">
        Separate facts from stories using EIER — Event → Interpretation → Evidence → Response.
      </GuidePillar>
      <GuidePillar title="Communicate with purpose">
        Translate examined thinking into words others can understand and trust.
      </GuidePillar>
      <GuidePillar title="Decide from reality">
        Name the emotion, examine the interpretation behind it — act on evidence, not fear.
      </GuidePillar>
    </GuidePillarGrid>
    <p className="guide-panel__p">
      This is the framework the Ahavibes product is built on. Each reflection walks the same four steps —
      record the event, name the interpretation, weigh the evidence, choose the response — so clarity becomes
      a repeatable procedure rather than an occasional insight.
    </p>
    <GuideCallout>
      In an age of information overload and artificial intelligence, the greatest advantage is not having more
      information—it is having the clarity to understand what truly matters and the confidence to act on it.
    </GuideCallout>
  </GuidePanel>
);

export default AhavibesPerspectiveSection;
